// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_BILLS_TO_PAY = 'GET_BILLS_TO_PAY';
export const GET_BILLS_TO_PAY_BY_HASH = 'GET_BILLS_TO_PAY_BY_HASH';
export const CREATE_BILLS_TO_PAY = 'CREATE_BILLS_TO_PAY';
export const UPDATE_BILLS_TO_PAY = 'UPDATE_BILLS_TO_PAY';
export const DELETE_BILLS_TO_PAY = 'DELETE_BILLS_TO_PAY';
